/**
 * Get the actual league ID from a league object
 * The API returns league_id as null, so we need to use the id field instead
 * @param {Object} league - League object from API
 * @returns {string|number|null} The league ID or null if not found
 */
export function getLeagueId(league) {
  if (!league) return null
  return league.id || league.league_id || null
}

/**
 * Check if a league has a valid ID
 * @param {Object} league - League object from API
 * @returns {boolean} True if league has a valid ID
 */
export function hasValidLeagueId(league) {
  const id = getLeagueId(league)
  return id !== null && id !== undefined
}

/**
 * Generate a league route URL
 * @param {Object} league - League object from API
 * @returns {string|null} The route URL or null if invalid league
 */
export function getLeagueRoute(league) {
  const id = getLeagueId(league)
  return id ? `/games/fixtures/league/${id}` : null
} 